import Com from "components/styledComp/CommStyledComp";
import React from "react";
import CompImg from "components/comp/CompImg";
import DevicesImg from "assets/images/hygateone/dashboard-devices.jpg";
import RemoteImg from "assets/images/hygateone/dashboard-remote.jpg";

const HyGateOneControlTower = () => {
  return (
    <Com.DivDetailSection border="false" id="control-tower">
      <Com.DivDetailHeading>
        <Com.DetailHeading>Smart Control Tower</Com.DetailHeading>
        <Com.DetailHeadingSmall>
          전 세계 어디서든, 단 하나의 대시보드로 관제
        </Com.DetailHeadingSmall>
      </Com.DivDetailHeading>
      <div className="strategy-list">
        <div className="strategy">
          <div className="schedule-dogyo">
            <Com.StrongStrategy underline={true}>통합 모니터링</Com.StrongStrategy>
            <div className="strategy-desc">
              <p>
                PC·모바일 한 화면에서 전 지점 출입 현황, 단말기 연결 상태,<br />
                시스템 상태를 실시간으로 파악합니다.
              </p>
            </div>
            <CompImg img={DevicesImg} width="100%" height="auto" fit="contain" />
          </div>
        </div>
        <div className="strategy">
          <div className="schedule-dogyo">
            <Com.StrongStrategy underline={true}>원격 제어</Com.StrongStrategy>
            <div className="strategy-desc">
              <p>
                클릭 한 번으로 도어 원격 개방·닫기·단말기 리부팅을 지원합니다.<br />
                출장 중에도 모바일로 즉시 현장에 대응할 수 있습니다.
              </p>
            </div>
            <CompImg img={RemoteImg} width="100%" height="auto" fit="contain" />
          </div>
        </div>
        <div className="strategy">
          <div className="schedule-dogyo">
            <Com.StrongStrategy underline={true}>장애 대응</Com.StrongStrategy>
            <div className="strategy-desc">
              <p>
                실시간 시스템 상태 모니터링으로 사고·장애 인지와<br />
                대응 속도를 높입니다.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Com.DivDetailSection>
  );
};

export default HyGateOneControlTower;
